const eNavbarTitles = {
  dashboard: "Dashboard",
  allPrices: "All Prices",
  contracts: "Contracts",
  olfChat: "OLF Chat",
  mySellers: "My Sellers",
  orderHistory: "Order History",
  manageOffers: "Manage Offers",
  orderCapture: "Order Capture",
  pricingEngine: "Pricing Engine",
  manageCustomers: "Manage Customers",
};

export { eNavbarTitles };
